var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElLockedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C3.89543 0 3 0.895431 3 2V5C1.89543 5 1 5.89543 1 7V12C1 13.1046 1.89543 14 3 14H11C12.1046 14 13 13.1046 13 12V7C13 5.89543 12.1046 5 11 5V2C11 0.895431 10.1046 0 9 0H5ZM9 5H5V3C5 2.44772 5.44772 2 6 2H8C8.55228 2 9 2.44772 9 3V5ZM7 8C6.44772 8 6 8.44771 6 9V10C6 10.5523 6.44772 11 7 11C7.55228 11 8 10.5523 8 10V9C8 8.44772 7.55228 8 7 8Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElLockedDark);
export default __webpack_public_path__ + "static/media/el-locked-dark.7ec6d150932a86bd7d8403a55795d865.svg";
export { ForwardRef as ReactComponent };